import React, {useEffect, useState, useRef} from 'react'
import { 
	Box, 
	useToast, 
} from '@chakra-ui/react'
import { FiCheckCircle } from 'react-icons/fi';
import intl from "../../utils/intl";
import { 
	CHAIN_ID, 
	NFT_ADDRESS, 
	BASE_API_URL, 
	ETHER_SCAN_URL, 
	DECIMAL, 
	SP_TOKEN_SYMBOL, 
	BASE_WEB_URL,
} from '../../config';
import {useAuth} from "../../contexts/AuthContext";
import { getSPToken, toDataURL, ipfsToHttp, format } from '../../utils/common';
import AudioPlayer from './AudioPlayer';

export const ItemBar = (props) => {
  const { currentAccount, currentNetwork, jwToken, myFavourTokenId } = useAuth();

	const [nftData, setNftData] = useState({});
	const [isFavour, setIsFavour] = useState(false);
	const [favours, setFavours] = useState(0);
	const [ isMine, setIsMine ] = useState(false);
	const [ isOnsale, setIsOnsale ] = useState(false);

	const loadingImage = 'assets/img/loading.jpg';
	const toast = useToast();

	useEffect(() => {
		const controller = new AbortController();
		const signal = controller.signal;

		const parseFromTokenURI = async(nftData) => {
			// console.log(d.tokenURI);
			if(nftData.tokenURI === undefined) return;
			const url = ipfsToHttp(nftData.tokenURI);
			// console.log(url);
			let res;
			try {
				res = await (await fetch(url, {
					method: 'GET',
					signal
				})).json();	
			} catch (err) {
				console.log(err);
			}

			if(res !== undefined) {
				try {
					// Get staking and sptoken data from contract
					const sptoken = await getSPToken(currentAccount, nftData.tokenId);

					// console.log("Item", {
					// 	...res,
					// 	...nftData,
					// 	...sptoken,
					// });	
					setNftData({
						...res,
						...nftData,
						...sptoken,
						imageBase64: res === undefined ? loadingImage : await toDataURL(ipfsToHttp(res.image))
					});

					// listPrice.current = nftData.startingPrice === null ? 0 : nftData.startingPrice;
					setFavours(nftData.favour);
					setIsMine(props.type * 1 === 1 || props.type * 1 === 2 || props.type * 1 === 3);
					setIsOnsale(props.type * 1 === 1 || props.type * 1 === 0);
				} catch (err) {
					console.log("Error: getSPToken");
				}
			}			
		}
		if(props.data !== undefined) parseFromTokenURI(props.data);
		return() => controller.abort();
	}, [props.data]);

	useEffect(() => {
		// console.log("+++++", myFavourTokenId, nftData.tokenId)
		setIsFavour(myFavourTokenId.includes(nftData.tokenId))
	}, [myFavourTokenId, nftData.tokenId, currentAccount, currentNetwork])

	const addFavour = async () => {
		// console.log('like db#', nftData.id, 'tokenId', nftData.tokenId, jwToken);
		const res = await fetch(`${BASE_API_URL}/items/add_favour`, {
			method: 'post',
			headers: {
				"Content-Type": "application/json",
				"Authorization": jwToken,
			},
			body: JSON.stringify({
				"chainId": CHAIN_ID,
				"nftAddress": NFT_ADDRESS,
				"tokenId": nftData.tokenId
			})
		})
		if(res.status === 401 && res.statusText === 'Unauthorized') {
			showError(intl.get("jwtoken_timeout"));
			return;
		}
		const data = await res.json();
		if(data.success) {
			setIsFavour(true);
			setFavours(favours + 1);
		}
	}

	const removeFavour = async() => {
		// console.log('remove favorite db#', nftData.id, 'tokenId', nftData.tokenId);
		const res = await fetch(`${BASE_API_URL}/items/remove_favour`, {
			method: 'post',
			headers: {
				"Content-Type": "application/json",
				"Authorization": jwToken,
			},
			body: JSON.stringify({
				"chainId": CHAIN_ID,
				"nftAddress": NFT_ADDRESS,
				"tokenId": nftData.tokenId
			})
		})
		if(res.status === 401 && res.statusText === 'Unauthorized') {
			showError(intl.get("jwtoken_timeout"));
			return;
		}
		const data = await res.json();
		if(data.success) {
			setIsFavour(false);
			setFavours(favours > 0 ? favours - 1 : 0);
		}
	}

	const showError = (msg) => {
		toast({
			title: intl.get("error"),
			description: msg,
			status: "error",
			duration: 4000,
			isClosable: true
		})
	}

	const isListed = () => props.type * 1 === 1 || props.type * 1 === 0;
	
	const StatusColumn = (props) => {
		return(
			<Box color="white" fontSize={11}>
				<Box display="flex" mb={2}>
				<FiCheckCircle/><Box ml={2} mt={-1}>{intl.get("support")}</Box>
				</Box>
				{!isListed() ? 
				isMine ? 
				<Box display="flex" mb={2}>
				<FiCheckCircle/><Box ml={2} mt={-1}>{intl.get("listable")}</Box>				
				</Box> : <></>
				 :
				isMine ?
				<Box>
					<Box display="flex" mb={2}>
					<FiCheckCircle/><Box ml={2} mt={-1}>{intl.get("my_nft")}</Box>
					</Box> 
					<Box display="flex" mb={2}>
					<FiCheckCircle/><Box ml={2} mt={-1}>{intl.get("change_price_available")}</Box>
					</Box> 
					<Box display="flex" mb={2}>
					<FiCheckCircle/><Box ml={2} mt={-1}>{intl.get("unlist_available")}</Box>
					</Box>
				</Box> :
				<Box display="flex" mb={2}>
				<FiCheckCircle/><Box ml={2} mt={-1}>{intl.get("can_buy")}</Box>
				</Box>}
			</Box>
		)
	}

	const openDetail = () => {
		if(nftData === undefined || nftData.tokenId === undefined) return;
		window.open(`${BASE_WEB_URL}id/${nftData.tokenId}`, '_blank', 'noopener,noreferrer');
	}

	return(
		<Box w={"300px"} mx={'auto'} >
				<AudioPlayer 
					tokenId={nftData.tokenId === undefined ? "" : nftData.tokenId}
					name={nftData.name === undefined ? "" : nftData.name}
					author={nftData.attributes === undefined || nftData.attributes.artist === undefined ? "" : nftData.attributes.artist}
					imageBase64={nftData.imageBase64 === undefined ? "" : nftData.imageBase64}
					audio={nftData.audio === undefined ? "" : ipfsToHttp(nftData.audio)}
					addFavour={() => addFavour()}
					removeFavour={() => removeFavour()}
					sptAddress={nftData.sptSymbol === undefined || nftData.sptAddress === undefined ? SP_TOKEN_SYMBOL :
						<a target="_blank" href={`${ETHER_SCAN_URL}address/${nftData.sptAddress}`} rel="noreferrer">{nftData.sptSymbol}</a>}
					sptMyBalance={nftData.sptMyBalance === undefined ? "0" : format(nftData.sptMyBalance / DECIMAL, 0)}
					sptBalance={nftData.sptBalance === undefined ? "0" : format(nftData.sptBalance / DECIMAL, 0)}
					isFavour={isFavour}
					favours={favours}
					openDetail={openDetail}
					setCurrentPlayingId={(bl) => props.setCurrentPlayingId(bl)}
					isPlay={props.isPlay}
					commingsoon={nftData.supportable === 0 && nftData.liquidityAddable === 0}
				/>
		</Box>
	)
}